export default {
    nav: {
        home: 'Início',
        products: 'Produtos',
        solutions: 'Soluções',
        support: 'Suporte',
        aboutUs: 'Sobre nós',
        contact: 'Contacte-nos'
    },
    hero: {
        title: 'Kooyii Smart<br>Soluções Completas para Espaços Inteligentes e Alarmes de Segurança',
        desc: 'A tornar os espaços mais inteligentes, seguros e protegidos.'
    },
    protocol: {
        title: 'Protocolos de Comunicação',
        cards: {
            zigbee: 'O Zigbee 3.0 é um padrão de comunicação sem fios unificado introduzido pela Connectivity Standards Alliance (CSA), permitindo uma interoperabilidade perfeita entre marcas e redes mesh de baixo consumo, ao integrar protocolos de aplicações fragmentados.',
            wifi: 'O Wi-Fi é uma tecnologia de rede sem fios reconhecida globalmente que transmite dados através de ondas de rádio, permitindo que os dispositivos se liguem a redes sem cabos físicos.',
            rf433: '433MHz é uma banda de rádio de baixa frequência comummente utilizada para dispositivos de curto alcance e baixo consumo de energia, como sistemas de alarme de segurança e interruptores inteligentes.',
            modbus: 'O Modbus é um protocolo de comunicação série amplamente utilizado na automação industrial, suportando a comunicação mestre-escravo e a troca de dados.',
            knx: 'KNX é uma tecnologia de barramento padrão europeia amplamente utilizada em sistemas de automação predial para edifícios inteligentes.',
            bluetooth: 'O Bluetooth é uma tecnologia sem fios para comunicação entre dispositivos, amplamente utilizada em hotéis inteligentes, casas inteligentes e outras áreas.'
        }
    },
    services: {
        title: 'Cenários de Aplicação',
        features: {
            smartHome: {
                title: 'Casa Inteligente',
                desc: 'Quebre as limitações das casas tradicionais para criar um espaço de habitação inteligente em todos os cenários. Com suporte a vários protocolos, como Zigbee e Wi-Fi, permite a interligação de dispositivos e a mudança de cenários de forma contínua. Desbloqueie um estilo de vida altamente eficiente e conveniente com operações minimalistas, trazendo o calor da tecnologia para a sua experiência de habitação.'
            },
            security: {
                title: 'Segurança Inteligente',
                desc: 'Uma central de alarme de segurança emparelhada com uma plataforma de monitorização profissional para construir um sistema de segurança integrado. Como núcleo do sistema, a central liga-se a vários detetores (infravermelhos, fumo, botões de emergência) através do protocolo de 433MHz, permitindo alertas em tempo real para intrusões, incêndios e emergências.'
            },
            hotel: {
                title: 'Hotel Inteligente',
                desc: 'Focada na IoT e combinada com uma plataforma de gestão de equipamentos hoteleiros, esta solução interliga quartos inteligentes, operações de receção e serviços de quarto, oferecendo valor duplo tanto para os hóspedes como para a gestão do hotel.'
            },
            building: {
                title: 'Automação de Edifícios',
                desc: 'Baseada em RTU e configurada através de um painel de gestão, suporta a integração de dispositivos Modbus para obter facilmente monitorização centralizada, controlo inteligente e gestão de energia dos equipamentos do edifício, transformando edifícios tradicionais em edifícios inteligentes.'
            }
        }
    },
    software: {
        title: 'Software e Plataformas',
        steps: {
            cms: { title: 'Centro de Receção de Alarmes', desc: 'Clique para visitar' },
            kooyii: { title: 'Kooyii', desc: 'Passe o rato para digitalizar e transferir' },
            elderly: { title: 'Cuidado Inteligente para Idosos', desc: 'Experiência ainda não disponível. Contacte as vendas para mais detalhes.' },
            hotel: { title: 'Hotel Inteligente', desc: 'Experiência ainda não disponível. Contacte as vendas para mais detalhes.' },
            building: { title: 'Automação de Edifícios', desc: 'Experiência ainda não disponível. Contacte as vendas para mais detalhes.' },
            more: { title: 'Mais Cenários', desc: 'Por favor, contacte a nossa equipa de vendas para aconselhamento profissional.' }
        }
    },
    solutions: {
        services: {
            title: 'Os Nossos Serviços',
            features: {
                hardware: {
                    title: 'Personalização de Hardware',
                    desc: 'Serviços exclusivos de conceção e fabrico de ponta a ponta, desde as placas PCBA principais até à estética completa do dispositivo. Abrange a conceção de circuitos, seleção de componentes, layout de PCB, depuração funcional, moldes de invólucro, materiais e proteção estrutural.'
                },
                software: {
                    title: 'Personalização de Software',
                    desc: 'Desenvolvimento de aplicações e sistemas web à medida com base nas suas necessidades de negócio reais, incluindo aplicações móveis (iOS/Android), páginas web para PC e gestão de back-office. Fornecemos uma solução digital altamente eficiente adaptada ao seu modelo operacional.'
                },
                server: {
                    title: 'Implementação Privada',
                    desc: 'Implemente sistemas, plataformas ou aplicações inteiramente nos seus próprios servidores ou ambientes de intranet designados. Os dados e os serviços funcionam de forma completamente independente, alcançando um controlo autónomo total.'
                }
            }
        },
        whyUs: {
            title: 'Porquê Escolher-nos?',
            benefits: {
                oneStop: {
                    title: 'Serviço Centralizado (One-Stop)',
                    desc: 'As nossas soluções cobrem software e hardware com um alinhamento unificado de ponta a ponta, eliminando a coordenação entre várias partes, encurtando os ciclos de desenvolvimento e reduzindo os custos de comunicação.'
                },
                custom: {
                    title: 'Personalização Profunda',
                    desc: 'Os recursos do software são combinados com precisão com o desempenho do hardware, evitando problemas de compatibilidade e garantindo um funcionamento geral mais suave com taxas de falha mais baixas.'
                },
                expandable: {
                    title: 'Alta Escalabilidade',
                    desc: 'Os nossos serviços reservam interfaces de expansão, tornando mais fácil para os clientes atualizar e expandir funcionalidades com base em necessidades futuras.'
                },
                deployment: {
                    title: 'Implementação Flexível',
                    desc: 'Seja uma implementação privada localizada ou uma implementação em cloud pública, fornecemos soluções flexíveis para atender às suas necessidades.'
                }
            }
        },
        cta: {
            title: 'Pronto para atualizar o seu estilo de vida?',
            desc: 'Fale com os nossos especialistas em casas inteligentes hoje e deixe-nos desenhar o ecossistema perfeito para si.',
            button: 'Contactar Vendas'
        }
    },
    product: {
        nav: {
            panel: 'Painéis de Controlo',
            hub: 'Hubs Inteligentes',
            switch: 'Interruptores Inteligentes',
            curtain: 'Cortinas Inteligentes',
            sensor: 'Sensores',
            lighting: 'Iluminação Inteligente',
            security: 'Segurança Inteligente',
            doorlock: 'Fechaduras Inteligentes'
        },
        sub: {
            '4inch': '4 Polegadas',
            '5inch': '5 Polegadas',
            '6inch': '6 Polegadas',
            '7inch': '7 Polegadas',
            '8inch': '8 Polegadas',
            '10inch': '10 Polegadas',
            '1gang': '1 Botão',
            '2gang': '2 Botões',
            '3gang': '3 Botões',
            '4gang': '4 Botões',
            wireless: 'Sem fios',
            wired: 'Com fios',
            'openclose': 'Motor de Cortina',
            'roller': 'Estores de Rolo',
            'downlight': 'Focos e Downlights',
            'magnetic': 'Calha Magnética',
            'strip': 'Fita LED',
            'alarm': 'Central de Alarme',
            'door': 'Sensor de Porta/Janela',
            'smoke': 'Detetor de Fumo',
            'infrared': 'Detetor de Infravermelhos',
            'radar': 'Radar de Presença Humana',
            'water': 'Sensor de Fuga de Água',
            'temp': 'Sensor de Temp. e Humidade',
            'indoorCam': 'Câmara Interior',
            'outdoorCam': 'Câmara Exterior',
            'password': 'Fechadura com Palavra-passe',
            'fingerprint': 'Fechadura Biométrica',
            'face': 'Fechadura com Rec. Facial'
        },
        common: {
            learnMore: 'Saber mais',
            addToCart: 'Adicionar ao carrinho',
            buyNow: 'Comprar agora',
            emptyProduct: 'Nenhum produto relacionado de momento. Fique atento...'
        },
        cart: {
            titleList: 'Lista de Pedidos',
            titleForm: 'Informações de Contacto',
            empty: 'A sua lista está vazia, vá adicionar alguns produtos!',
            delete: 'Eliminar',
            totalItems: 'Total de {count} produtos selecionados',
            nextStep: 'Próximo Passo: Preencher Informações',
            submit: 'Enviar Pedido'
        },
        form: {
            name: 'Como devemos chamá-lo?',
            namePlaceholder: 'Por favor, insira o seu nome',
            address: 'Morada da Empresa',
            addressPlaceholder: 'Insira a morada detalhada da sua empresa',
            location: 'Cidade / País',
            locationPlaceholder: 'Ex: Lisboa, Portugal',
            whatsapp: 'WhatsApp',
            whatsappPlaceholder: 'Insira o seu WhatsApp para que possamos contactá-lo',
            email: 'E-mail',
            emailPlaceholder: 'Insira o seu e-mail para que possamos contactá-lo',
            remark: 'Observações',
            remarkPlaceholder: 'Insira quaisquer observações para entendermos melhor as suas necessidades'
        },
        alert: {
            fillRequired: 'Por favor, preencha todos os campos obrigatórios (marcados com *)',
            submitSuccess: 'Pedido enviado com sucesso! A nossa equipa de vendas entrará em contacto em breve.'
        }
    },
    contact: {
        hero: {
            title: 'Contacte-nos',
            desc: 'Obtenha aconselhamento profissional e as soluções mais adequadas para si'
        },
        form: {
            title: 'Envie-nos uma mensagem',
            subtitle: 'Preencha o formulário abaixo e responderemos no prazo de 24 horas.',
            firstName: 'Nome',
            firstNamePlaceholder: 'Ex: João',
            lastName: 'Apelido',
            lastNamePlaceholder: 'Ex: Silva',
            email: 'E-mail corporativo',
            emailPlaceholder: "joao{'@'}empresa.pt",
            inquiryType: 'Tipo de consulta',
            selectTopic: 'Selecione um tópico...',
            message: 'Mensagem',
            messagePlaceholder: 'Como podemos ajudá-lo?',
            submitBtn: 'Enviar Mensagem',
            sending: 'A enviar...',
            successMsg: 'Obrigado! A sua mensagem foi enviada com sucesso.'
        },
        inquiry: {
            general: 'Pergunta Geral',
            sales: 'Vendas e Distribuição',
            support: 'Suporte Técnico',
            hardware: 'OEM/ODM',
        },
        location: {
            title: 'Onde Estamos',
            officeName: 'Sede em Shenzhen',
            address: 'Sala 603, Unidade 1, Edifício 1, Praça Kailifang, Rua Lianrun, Comunidade Taoyuan, Rua Dalang, Distrito de Longhua, Shenzhen, Guangdong, China',
            phone: '+86 18926403313 Sra. Yuan'
        }
    },
    footer: {
        companyName: 'Shenzhen Golden Security Technology Co., Ltd.'
    }
}